import React, { Component } from 'react';
import { Portal } from 'react-portal';
import moment from 'moment';
import PropTypes from 'prop-types';

import { SR_API_ACTION_ADMIN_ADD_SHOWING_TO_TOUR } from 'api/actionTypes';

import { DATA_TABLE_SOURCE_ADMIN_TOURS } from 'common/dataTableConstants';

import postWithState from 'client/actions/postWithState';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import withApiState from 'client/helpers/withApiState';
import branch from 'client/core/branch';

import { actionDataTableRemoveItem, actionDataTableLoadItems } from 'client/helpers/dataTables';

@withApiState({
  addToTourApiState: {
    action: SR_API_ACTION_ADMIN_ADD_SHOWING_TO_TOUR,
  },
})
@branch({})
class SrAdminToursAddToTourList extends Component {
  static propTypes = {
    tour: PropTypes.object,
    tourListingToBeAdded: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
  };

  constructor(props, context) {
    super(props, context);

    this.initialState = {
      tours: null,
    };
    this.state = this.initialState;
  }

  _reloadDataTableTour = (params) => {
    const { tour, dispatch } = this.props;

    const tourIdToLoad =
      params && typeof params === 'object' && typeof params.tourIdToLoad === 'number'
        ? params.tourIdToLoad
        : tour.id;

    return dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
      viewId: `tour-id-${tourIdToLoad}`,
      filter: {
        'tours.id': tourIdToLoad,
      },
      count: 1,
    });
  };

  _handleSubmit = (event, newTourId) => {
    event.preventDefault();
    this._addToTour(newTourId);
  };

  _addToTour = (newTourId) => {
    event.preventDefault();

    const { tourListingToBeAdded, dispatch, onClose } = this.props;

    const userName = tourListingToBeAdded.tour.user.name;

    dispatch(postWithState, {
      action: SR_API_ACTION_ADMIN_ADD_SHOWING_TO_TOUR,
      queryId: `${tourListingToBeAdded.tour.id}-${tourListingToBeAdded.listingId}`,
      payload: {
        originalTourId: tourListingToBeAdded.tour.id,
        listingId: tourListingToBeAdded.listingId,
        newTourId: newTourId,
      },
    }).then((result) => {
      if (!result.listingNewTourId) {
        global.alert(`Whoops, ${userName} does not have a scheduled tour.`);
      } else {
        global.alert(`Listing has been added to ${userName}'s scheduled tour.`);

        return Promise.all([
          this._reloadDataTableTour({
            tourIdToLoad: result.listingNewTourId,
          }),
          tourListingToBeAdded.tour.listings.length > 1
            ? this._reloadDataTableTour({
                tourIdToLoad: tourListingToBeAdded.tour.id,
              })
            : dispatch(actionDataTableRemoveItem, {
                dataSource: DATA_TABLE_SOURCE_ADMIN_TOURS,
                entityId: tourListingToBeAdded.tour.id,
              }),
        ]);
      }
    });
    onClose();
  };

  render() {
    const { addToTourApiState, onClose, isOpen, tourListingToBeAdded } = this.props;

    const isDisabled = addToTourApiState.inProgress;

    if (!isOpen) {
      return null;
    }

    const userName = tourListingToBeAdded.tour.user.name;

    return (
      <Portal>
        <div className="addToTourList">
          <div className="backdrop" onClick={onClose}>
            <div className="form" onClick={(evt) => evt.stopPropagation()}>
              {tourListingToBeAdded.userTours.length > 0 ? (
                <h1>{userName}'s scheduled tours</h1>
              ) : (
                <h1>{userName} has no scheduled tours</h1>
              )}
              {tourListingToBeAdded.userTours.map((tour) => (
                <div className="addToTourButtonWrapper" key={tour.id}>
                  <ButtonDeprecated
                    onClick={(event) => this._handleSubmit(event, tour.id)}
                    disabled={isDisabled}
                  >
                    {moment(tour.startDate).format('MM/DD/YYYY [at] h:mmA')}
                  </ButtonDeprecated>
                </div>
              ))}

              {addToTourApiState.error && (
                <div className="errorMessage">{addToTourApiState.error.message}</div>
              )}
            </div>
          </div>
        </div>
      </Portal>
    );
  }
}

SrAdminToursAddToTourList.displayName = 'SrAdminToursAddToTourList';

export default SrAdminToursAddToTourList;
